const A = 10, _ = 184;
export {
  _ as MAX_CAMPAIGN_PERIOD_DAYS,
  A as MIN_CAMPAIGN_PERIOD_DAYS
};
